module.exports = __webpack_public_path__ + "static/media/rotate-left.b627b5a4.svg";